import { api } from '../api';
import type {
  ConsolidatedProfilesResponse,
  EntityResolveRequest,
  EntityResolveResponse,
  FullLoadCommitResponse,
  FullLoadValidateResponse,
} from '@/types/m25';

export const m25Api = api.injectEndpoints({
  endpoints: (builder) => ({
    resolveEntity: builder.mutation<EntityResolveResponse, EntityResolveRequest>({
      query: (body) => ({ url: '/entities/resolve', method: 'POST', body }),
    }),
    getConsolidatedProfiles: builder.query<ConsolidatedProfilesResponse, number[]>({
      query: (profileIds) => {
        const bounded = profileIds.slice(0, 20);
        const qs = bounded.map(String).join(',');
        return `/requirement-profiles/consolidated?profileIds=${qs}`;
      },
    }),
    validateFullLoad: builder.mutation<FullLoadValidateResponse, Record<string, unknown>>({
      query: (body) => ({ url: '/associations/full-load/validate', method: 'POST', body }),
    }),
    commitFullLoad: builder.mutation<FullLoadCommitResponse, Record<string, unknown>>({
      query: (body) => ({ url: '/associations/full-load', method: 'POST', body }),
      invalidatesTags: [{ type: 'Association', id: 'LIST' }, { type: 'Entity', id: 'LIST' }],
    }),
    rollbackFullLoad: builder.mutation<
      { jobId: string; status: string; rolledBack: boolean },
      { jobId: string; reason?: string }
    >({
      query: ({ jobId, reason }) => ({
        url: `/associations/full-load/${jobId}/rollback`,
        method: 'POST',
        body: reason ? { reason } : {},
      }),
      invalidatesTags: [{ type: 'Association', id: 'LIST' }, { type: 'Entity', id: 'LIST' }],
    }),
  }),
});

export const {
  useResolveEntityMutation,
  useGetConsolidatedProfilesQuery,
  useValidateFullLoadMutation,
  useCommitFullLoadMutation,
  useRollbackFullLoadMutation,
} = m25Api;
